import { useState } from 'react'
import { t, Trans } from '@lingui/macro'
import { Button, MenuItem } from '@mui/material'
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded'

import DeleteConfirmationDialog from '@/components/ui/dialogs/DeleteConfirmationDialog'
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen'

import { useDeletePatient } from '../../model/useDeletePatient'

type DeletePatientProps = {
  onClose?: () => void
  patientId: string
}

export function DeletePatient({ patientId }: DeletePatientProps) {
  const isLargeScreen = useIsLargeScreen()

  const { deletePatient, isDeletingPatient } = useDeletePatient(patientId)

  const [openDeleteConfirmaionDialog, setOpenDeleteConfirmationDialog] = useState(false)

  return (
    <>
      {isLargeScreen ? (
        <Button color="error" disableElevation onClick={() => setOpenDeleteConfirmationDialog(true)} startIcon={<DeleteRoundedIcon />} variant="contained" data-testid="patient-delete-button">
          <Trans>Delete</Trans>
        </Button>
      ) : (
        <MenuItem
          onClick={() => {
            setOpenDeleteConfirmationDialog(true)
          }}
          disableRipple
          data-testid="patient-delete-button"
        >
          <DeleteRoundedIcon />
          <Trans>Delete</Trans>
        </MenuItem>
      )}
      <DeleteConfirmationDialog
        isDeleting={isDeletingPatient}
        maxWidth={700}
        onClose={() => setOpenDeleteConfirmationDialog(false)}
        onDelete={deletePatient}
        open={openDeleteConfirmaionDialog}
        title={t`Do you want to delete this patient ?`}
        message={t`Please note that deleting the patient data causes the loss of information. Please confirm deletion.`}
      />
    </>
  )
}
